import { useEffect, useRef, useState } from "react";

import {
  faDownLong,
  faPenToSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useLanguage } from "../../contexts/LanguageContext";

import "./EventHeaderMenu.css";

const EventHeaderMenu = ({
  event,
  onDeleteEvent,
  onShareEvent,
  onEditEvent,
  onDownloadCodeEvent,
  user,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const { t } = useLanguage();

  // Cerrar menú cuando se hace clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen]);

  // Cerrar menú con tecla Escape
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape" && isOpen) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen]);

  const handleMenuToggle = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleMenuItemClick = (action, e) => {
    e.stopPropagation();
    setIsOpen(false);

    switch (action) {
      case "edit":
        onEditEvent?.(event);
        break;
      case "share":
        onShareEvent?.(event);
        break;
      case "copy":
        navigator.clipboard.writeText(event.shareUrl);
        break;
      case "delete":
        onDeleteEvent?.(event);
        break;
      case "download":
        onDownloadCodeEvent?.(event);
        break;
      default:
        break;
    }
  };

  return (
    <div className="event-header-menu">
      <button
        ref={buttonRef}
        className="event-header-menu-button"
        onClick={handleMenuToggle}
        aria-label="Event options"
        aria-haspopup="true"
        aria-expanded={isOpen}
        title="Event options"
      >
        Editar Evento
      </button>

      {isOpen && (
        <>
          <div className="event-menu-backdrop" />
          <div
            ref={menuRef}
            className={`event-menu-dropdown ${isOpen ? "open" : ""}`}
            role="menu"
          >
            <button
              className="event-menu-item"
              onClick={(e) => handleMenuItemClick("download", e)}
              role="menuitem"
              title={t("dashboard.downloadCode")}
            >
              <FontAwesomeIcon icon={faDownLong} />
              <span>{t("dashboard.downloadCode")}</span>
            </button>

            <div className="event-menu-separator" />

            <button
              className="event-menu-item"
              onClick={(e) => handleMenuItemClick("edit", e)}
              role="menuitem"
              title={t("dashboard.editEvent.title")}
            >
              <FontAwesomeIcon icon={faPenToSquare} />
              <span>{t("dashboard.editEvent.title")}</span>
            </button>

            {user?.isPremium && (
              <button
                className="event-menu-item danger"
                onClick={(e) => handleMenuItemClick("delete", e)}
                role="menuitem"
                title={t("dashboard.modalDeleteEvent.deleteEvent")}
              >
                <FontAwesomeIcon icon={faTrash} />
                <span>{t("dashboard.modalDeleteEvent.deleteEvent")}</span>
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default EventHeaderMenu;
